/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI',
	'../../../widgets/livewidget/nls/StringResources'
], function(APIFactory, PropertiesProviderAPI, StringResources) {

	const PROP_ID_EXPANDCOLLAPSE = 'expandCollapse';

	class ExpandCollapsePropertyProvider {

		constructor(options) {
			this.content = options.content;
			// register self as a 'Properties' provider
			this.content && this.content.getFeature('Properties').registerProvider(this.getAPI());
			this.dashboard = options.dashboardAPI;
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);
			}
			return this._api;
		}

		destroy() {
			this.dashboard = null;
			this.content = null;
		}

		getPropertyLayoutList() {
			return [];
		}

		getPropertyList() {
			const propertyList = [];
			if (this._isSupported()) {
				propertyList.push({
					id: PROP_ID_EXPANDCOLLAPSE,
					editor: {
						'sectionId': 'visualization.chart',
						uiControl: {
							type: 'ToggleButton',
							defaultValue: true,
							label: StringResources.get(PROP_ID_EXPANDCOLLAPSE),
							onChange: (propertyName, propertyValue) => {
								this.content.setPropertyValue(propertyName, propertyValue);
							}
						}
					},
					onPropertyChange: {
						refresh: {
							data: true
						}
					},
					defaultValue: true
				});
			}
			return propertyList;
		}

		_isSupported() {
			const expandCollapseFeatureFlag = !this.dashboard.getGlassCoreSvc('.FeatureChecker').checkValue('dashboard', 'expandCollapse', 'disabled');
			if (expandCollapseFeatureFlag) {
				const visApi = this.content.getFeature('Visualization');
				return visApi && this._isSupportedVisType(visApi) && this._isOlap(visApi);
			} else {
				return false;
			}
		}

		_isSupportedVisType(visApi) {
			return visApi.getType() === 'Crosstab';
		}

		_isOlap(visApi) {
			const mappedSlot = visApi.getSlots().getMappedSlotList();
			const dataItem = mappedSlot && mappedSlot[0] && mappedSlot[0].getDataItemList()[0];
			return dataItem && dataItem.getMetadataColumn().isOlapColumn() || false;
		}
	}

	return ExpandCollapsePropertyProvider;
});
